import { Instagram, MessageSquare, Music2, Youtube } from 'lucide-react'
import { SocialPlatform } from '@digital-twins/shared-types'
import { cn } from '@/lib/utils'

interface SocialPlatformIconProps {
  platform: SocialPlatform
  className?: string
}

/** lucide has no Reddit or TikTok mark: a generic glyph stands in. */
const PLATFORM_ICONS: Record<SocialPlatform, typeof MessageSquare> = {
  reddit: MessageSquare,
  youtube: Youtube,
  tiktok: Music2,
  instagram: Instagram,
}

export function SocialPlatformIcon(props: SocialPlatformIconProps) {
  const { platform, className } = props

  const Icon = PLATFORM_ICONS[platform]
  return <Icon className={cn('h-4 w-4 shrink-0', className)} aria-hidden="true" />
}
